import { NavigableModal } from '$components'
import { useNavigate, useParams } from 'react-router-dom'
import { EditServiceDetailsForm, EditServiceDetailsSchema, Input } from '$features/services/forms/edit-service-details/index'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { serviceShowOptions, serviceShowQueryKey, serviceUpdateMutation } from '$api-client/@tanstack/react-query.gen'
import { ToastHelper } from '$components'

export function EditServiceDetailsModal() {
  const navigate = useNavigate()
  const { id } = useParams()
  const queryClient = useQueryClient()

  const { data } = useQuery({
    ...serviceShowOptions({
      path: {
        id: Number(id),
      },
      query: {
        include_deleted: true,
      },
    }),
  })

  const { mutate: updateService, isPending: isUpdatingService } = useMutation({
    ...serviceUpdateMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: serviceShowQueryKey({
          path: {
            id: Number(id),
          },
        }),
      })
      ToastHelper.success('Service details updated successfully.')
      handleClose()
    },
    onError: () => ToastHelper.error('Failed to update service details.'),
  })

  const handleClose = () => navigate(-1)

  const handleSubmit = async (values: EditServiceDetailsSchema) => {
    updateService({
      path: {
        id: Number(id),
      },
      body: {
        name: values[Input.Name],
        colour: values[Input.Colour],
      },
    })
  }

  const service = data?.data

  if (!service) {
    return null
  }

  return (
    <EditServiceDetailsForm
      onSubmit={handleSubmit}
      onCancel={handleClose}
      isLoading={isUpdatingService}
      defaultValues={{
        [Input.Name]: service.values?.name,
        [Input.Colour]: service.colour,
      }}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Edit Service Details
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <EditServiceDetailsForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <EditServiceDetailsForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </EditServiceDetailsForm>
  )
}
